import ticketsRoute from "./tickets.Route";
import supportMailRoute from "./SupportMail/supportMail.Route";

// The literal /tickets/support-mail first, for the reason clientsRoutesList puts
// InquiryQueue before ClientDetail.
const ticketsRoutesList = [...supportMailRoute, ...ticketsRoute];

export default ticketsRoutesList;
